<template>
<!-- 游戏线路管理管理页 -->
  <div class="birthdayRight">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>游戏路线列表查询</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="search_box">
      <!-- <span style="margin-left:15px;">游戏线路管理状态：</span>
        <el-select v-model="optStatus" placeholder="请选择">
          <el-option
            v-for="item in statusOption"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select> -->
      <el-button
        type="primary"
        class="btn"
        @click="onOpenQuery"
      >
        添加
      </el-button>
    </div>
    <el-table
      border
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column  type="selection" width="55"> </el-table-column>
       <el-table-column align="center" prop="dept" label="排序">
        <template slot-scope=" {row} ">
          <el-input
            type="number"
            class="input-new-tag"
            v-model="row.dept"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="handleInputConfirm(row)"
            @blur="handleInputConfirm(row)"
          >
          </el-input>
          <!-- <el-button class="button-new-tag" @click="onChangeSort(row)" v-else>
            {{row.dept}}
            </el-button> -->
        </template>
      </el-table-column>
      <el-table-column  prop="infoId" label="ID"> </el-table-column>
      <el-table-column  prop="addTime" label="添加时间"> </el-table-column>
      <el-table-column  prop="lineName" label="活动名称"> </el-table-column>
      <el-table-column  prop="placeName" label="打卡地名称"> </el-table-column>
      <el-table-column prop="imgUrl" label="介绍图">
         <template slot-scope="{ row }">
          <el-image
            fit="fill"
            style="width:50px"
            :src="row.imgUrl"
            :preview-src-list="[row.imgUrl]"
          ></el-image>
        </template>
         </el-table-column>
      <el-table-column label="操作" width="300">
        <template slot-scope="{ row }">
             <el-button
            size="mini"
            type="primary"
            style="margin-left: 10px"
            @click="isAble(row.lineId,row.status)"
            v-if="row.status == 2"
          >
            启用
          </el-button>
            <el-button
            type="primary"
            size="mini"
            style="margin-left: 10px"
            @click="isAble(row.lineId,row.status)"
            v-if="row.status == 1"
          >
            禁用
          </el-button>
          <el-button
            type="primary"
            size="mini"
            style="margin-left: 10px"
            @click="removeLine1(row.infoId)"
          >
            删除
          </el-button>
        <!-- <el-button type="primary" size="mini" @click="goEdit(row.lineId)">编辑</el-button> -->
        <el-button type="primary" size="mini" @click="openDialog(row.infoId,row.placeName)">生成二维码</el-button>
               <el-dialog
              title="提示"
              :visible.sync="dialogVisible"
              width="30%"
              :before-close="handleClose">
              <span>是否启用？</span>
     <span slot="footer" class="dialog-footer">
           <el-button @click="dialogVisible = false">取 消</el-button>
           <el-button type="primary" @click="turnOn()">确 定</el-button>
      </span>
    </el-dialog>
               <el-dialog
     title="提示"
     :visible.sync="dialogVisible2"
     width="30%"
     :before-close="handleClose">
     <span>是否禁用？</span>
     <span slot="footer" class="dialog-footer">
           <el-button @click="dialogVisible2 = false">取 消</el-button>
           <el-button type="primary" @click="turnOff()">确 定</el-button>
      </span>
    </el-dialog>
               <el-dialog
     title="提示"
     :visible.sync="dialogVisible3"
     width="30%"
     :before-close="handleClose">
     <span>是否删除？</span>
     <span slot="footer" class="dialog-footer">
           <el-button @click="dialogVisible3 = false">取 消</el-button>
           <el-button type="primary" @click="removeLine(row.infoId)">确 定</el-button>
      </span>
    </el-dialog>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pagination.currentPage"
      :page-sizes="[5, 10, 15, 20]"
      :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total"
    >
    </el-pagination>
    <!-- 添加的弹窗 -->
    <el-dialog title="添加路线" :visible.sync="openAdd" width="50%">
      <el-table
      border
      ref="multipleTable2"
      :data="innerTableData"
      tooltip-effect="dark"
      style="width: 30"
      @selection-change="handleSelectionChange"
      >
    <el-table-column align="center" type="selection" width="150"> </el-table-column>
      <el-table-column align="center" prop="placeId" label="打卡地Id"> </el-table-column>
      <el-table-column align="center" prop="placeName" label="打卡地名称"> </el-table-column>
      <el-table-column align="center" prop="imgUrl" label="图片"> 
           <template slot-scope="{ row }">
          <el-image
            :zIndex='2008'
            style="width:50px"
            fit="fill"
            :src="row.imgUrl"
            :preview-src-list="[row.imgUrl]"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column  label="操作" align="center">
          <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            style="margin-left: 10px"
            @click="addCheckPoint(scope.$index,scope.row.placeId)"
          >
            添加
          </el-button> 
          </template>
          </el-table-column>
   
      </el-table>
      <div class="pag">
          <el-button
            type="primary"
            size="mini"
            style="margin-left: 10px"
            @click="selectCheckPoint()"
          >
            添加选中项
          </el-button> 
        <el-pagination
         @size-change="handleSizeChange"
         @current-change="handleCurrentChange"
         :current-page="pagination.currentPage"
         :page-sizes="[5, 10, 15, 20]"
         :page-size="pagination.pageSize"
         layout="total, sizes, prev, pager, next, jumper"
         :total="pagination.total"
         >
         </el-pagination>
      </div>
    </el-dialog>
        <el-dialog
          title="提示"
          :visible.sync="codeVisible"
          width="30%"
          :before-close="handleClose"
          >
          <div class="inner_top">
   <el-input
        style="width:300px"
        v-model.trim="QRcodeSize"
        placeholder="请输入生成的二维码大小"
        ></el-input>
        
          <el-button type="primary" @click="generateQRcode">生成</el-button>
        </div>
                <div style="color:red">推荐宽度：280px-1280px</div>
        <el-image
            
            v-show="imgUrl"
            fit="fill"
            :src="imgUrl"
          ></el-image>
  <span slot="footer" class="dialog-footer">
    <span>右键点击图片，点击另存为保存图片</span>
    <el-button @click="codeVisible = false">取 消</el-button>
    <el-button type="primary" @click="codeVisible = false">确 定</el-button>
  </span>
</el-dialog>
  </div>
</template>
<script>
import productBox from "../productBox";
import { 
theGameLineAPI,
canUseCheckPointAPI,
addCheckPointAPI,
removeCheckPointAPI,
generateQRcodeAPI,
lineDeptAPI
} from "../../../api/smart.js";
export default {
  name: "activeList",
    components:{
    productBox
    },
  data() {
    return {
      // canInput:false,
      isVisible:false,
      imgUrl:'',
      QRcodeSize:'',
      codeVisible:false,
        openAdd:false,
      gameStatus:[],
        tableData:[],
      showAddress: false,
      address: "",
      formData: {
        status: null,
        title: "",
        pageSize: 10,
        currentPage: 1,
      },
      multipleSelection: [],
      tableData: [],
      pagination: {},
      dialogVisible: false,
      dialogVisible2: false,
      dialogVisible3: false,
      detailData:[],
      gameId:'',
      lineId:'',
      infoId:'',
      abl:'',
      statusOption:[{
          value: -2,
          label: '全部'
        }, {
          value: 1,
          label: '正常'
        }, {
          value: 0,
          label: '禁用'
        }],
        optStatus:'',
        innerTableData:[]
    };
  },
  created() {
    this.getGameLineList();
    this.canUseCheckPoint()
  },
  methods: {
     onChangeSort(row) {
       console.log(row);
      row.inputVisible = true;
    
      // console.log(index);
      //     let tableData = this.tableData
      //   console.log(tableData[index],'这是什么')
    },
    async handleInputConfirm(row) {
      // console.log(row,'asdasdrow')
      const { data } = await lineDeptAPI({
        infoId: row.infoId,
        dept: Number(row.dept),
      });
      console.log(data,'laskdjlkasjdlkasd')
      if (data.code === 0) {
        row.inputVisible = false;
        this.getGameLineList();
        this.$message.success(data.msg);
      } else {
        this.$message.error(data.msg);
      }
    },
    onOpenQuery(){
      this.openAdd = true
      this.canUseCheckPoint()
    },
    openDialog(row,placeName){
      this.imgUrl = ''
       this.widthSize = ''
       this.placeName = placeName
      console.log(row,'infoId');
      this.codeVisible = true
      this.infoId = row
    },
   async generateQRcode(){
     this.imgUrl = ''
     if(!this.QRcodeSize){
       this.$message({ message: "请输入宽度", type: "warning" }); 
     }else{
      const {data} = await generateQRcodeAPI({
        infoId:this.infoId,
        widthSize:this.QRcodeSize
      })
      this.imgUrl = data.msg
      console.log(this.imgUrl);
     }
     
    },
      removeLine1(infoId){
          this.dialogVisible3 = true
          this.infoId = infoId
      },
      async removeLine(){
          await removeCheckPointAPI({infoId:this.infoId})
            setTimeout(() => {
                this.getGameLineList();
                this.dialogVisible3 = false
            }, 500);
          
      },
        async selectCheckPoint(row){
        var data = this.$refs.multipleTable2.selection;
        console.log(data,'alksdkjaslkdj');
          let arr = []
          data.map(item=>{
              item.placeId
              arr.push(item.placeId)
          })
            let str =   arr.join(',')
          let lineId = Number(this.$route.query.lineId)
          if(data.length == 0)return this.$message({ message: "请选择路线", type: "warning" }); 
         const {datas} = await addCheckPointAPI({
              lineId,
              placeIds:str
          })
         if(data || datas.code == 0){
            this.innerTableData.splice(0,data.length)
             this.$message({ message: "添加成功", type: "success" }); 
             this.getGameLineList();
         }
        },
      async addCheckPoint(index,placeIds){
        console.log(index,placeIds,'添加');
           let lineId = Number(this.$route.query.lineId)
          await addCheckPointAPI({
              lineId,
              placeIds:placeIds
          })
          if(placeIds){
            console.log( this.innerTableData.splice(index,1))
           this.getGameLineList()
              this.$message({ message: "添加成功", type: "success" }); 
          }
      },
    goDetail(){
    },
    async canUseCheckPoint(){
        const { data } = await canUseCheckPointAPI({lineId:this.$route.query.lineId})
        console.log(data);
        this.innerTableData = data.data
        console.log(this.innerTableData,'里面的数据');
    },
      isAble(row,status){
        console.log('isAble',row)
        this.lineId = row
        if(status == 1){
            this.dialogVisible2 = true
        }else{
            this.dialogVisible = true
        }
      },
      closeModal(){
        this.turnOn()
        this.dialogVisible=false
      },
       handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      //搜索游戏线路管理列表
      //游戏线路管理详情
      goEdit(row,row2,row3){
          console.log('goEdit',row)
         this.$router.push(`/addGameLine?lineId=${row}`)
      },
      //游戏线路管理列表
      async getGameLineList(){
          const {data} = await theGameLineAPI({
              pageSize:this.formData.pageSize,
              currentPage:this.formData.currentPage,
              lineId:this.$route.query.lineId,
          })
          this.tableData = data.list;
          this.tableData.map(item=>{
            item.inputVisible=false
          })
          this.pagination = data.pagination
          console.log(this.tableData,'data');
      },
      //启动
        async turnOn(row,status){
        await manageLineAPI({
              lineId:this.lineId,
              status:1,
          })
        setTimeout(() => {
            this.dialogVisible =false
        }, 200);
            this.$message({ message: "启用成功", type: "success" }); 
            this.getGameLineList()
      },
      //禁用
      async turnOff(){
          await manageLineAPI({
            lineId:this.lineId,
            status:2,
          })
            setTimeout(() => {
                this.dialogVisible2 =false
        }, 200);
                this.$message({ message: "禁用成功", type: "success" }); 
                this.getGameLineList()
      },
    onShowAddress(id) {
      this.address = "components/navPages/navPages?activityId=" + id;
      this.showAddress = true;
    },
    copyinviteUrl() {
      this.$nextTick(() => {
       var inputElement =  document.getElementById("wrapper");
       //选中input框的内容
       inputElement.select();
        // 执行浏览器复制命令
       document.execCommand("Copy");
        this.$message({ message: "复制成功", type: "success" }); //此处为结合使用element-ui的Message 消息提示组件
      });
    },

    hideVisible() {
      this.dialogVisible2 = false;
    },
    handleSelectionChange(arr) {
      var data = [];
      arr.forEach((item) => {
        data.push(item.activityId);
      });
      this.multipleSelection = data;
      console.log(this.multipleSelection);
    },
    handleSizeChange(num) {
      console.log(num);
      this.formData.pageSize = num;
      this.getTableList();
    },
    handleCurrentChange(num) {
      console.log("currentPage", num);
      this.formData.currentPage = num;
      this.getTableList();
    },
    onInput(value) {
      var reg = /^(0\.?\d{0,5}|[1-9]\d*\.?\d{0,5})$/;
      if (!reg.test(value)) {
        return this.$message({
          type: "error",
          message: "请输入正确的数字!",
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.birthdayRight {
  .el-breadcrumb {
    height: 35px;
    border-bottom: 1px solid rgb(192, 191, 191);
  }
  .btn_box {
    float: left;
    margin-top: 50px;
  }
  .add {
    margin-top: 20px;
  }
  .el-table {
    margin-top: 50px;
  }
  .search_box {
    margin-top: 24px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .el-input {
      width: 200px;
    }
    .btn {
      margin-left: 20px;
    }
  }
  .el-pagination {
    margin-top: 50px;
    float: right;
  }
  /deep/.el-dialog__header {
    border-bottom: 1px solid #f1f1f1;
  }
  /deep/.el-dialog__footer {
    border-top: 1px solid #f1f1f1;
  }
  .tips {
    // text-align: right;
    color: orangered;
  }
  .grade_list {
    padding: 0 10px 10px;
    .grade_item {
      border-bottom: 1px solid #f1f1f1;
      margin-bottom: 20px;
      &:last-child {
        border-bottom: none;
        margin-bottom: 0;
      }
      .grade_name {
        font-weight: bold;
        margin: 0px 0 10px;
      }
      .form_item {
        display: flex;
        .el-form-item {
          flex: 1;
          .el-input-number {
            width: 100%;
          }
        }
      }
    }
  }
  .btn_box {
    margin-top: 24px;
  }
  .modify_btn {
    padding-left: 10px;
    padding-right: 10px;
  }
  /deep/.popconfirm {
    margin-right: 10px;
  }
  #address {
    display: flex;
    align-items: center;

    .el-input {
      width: 350px;
    }
  }
}
.el-dialog{
  .inner_top{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .el-image{
    width: 100%;
  }
z-index: -1;
.el-table[data-v-fd3bb618]{
    margin:0
    }
 .el-pagination[data-v-fd3bb618]{
     margin: 0;
     float: none;
 }
}
.pag{
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

</style>